import React from 'react'
import { useFeatureFlags } from '@node-space/hooks'
import { Button, Icon } from '@node-space/ui-components'
import { useThemeContext } from 'hooks/context/useThemeContext'

export const DarkModeToggle = () => {
  const { enableDarkMode } = useFeatureFlags()

  const { darkMode, setDarkMode } = useThemeContext()

  const toggleDarkMode = () => {
    setDarkMode(prev => !prev)
  }

  // Return null if feature flag is disabled
  if (!enableDarkMode) {
    return null
  }

  return (
    <Button
      variant="ghost"
      onClick={toggleDarkMode}
      iconElement={<Icon name={darkMode ? 'SmileySad' : 'Smiley'} size="medium" />}
      noPadding
      className="h-10 w-10 rounded-full"
      testId="dark-mode-toggle"
      aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    />
  )
}
